import cloneDeep from 'lodash/cloneDeep';
import * as actions from './course-assign-types';
import { customSort } from '../../components/student-list/student-list-util';
import { isDefined } from '../../helpers/utils';
import PortalCommunication from '../../helpers/portal-comms';
import {
  updateStrandAndStandards,
  updateStrands,
  updateGridCells,
  getSelectedStandardCount,
  updateSelectedTopics,
  updateActivitySelection,
  getFilteredTopics,
  updateCheckedStatus,
  updateHiddenTopics,
  checkIfAssignmentPassesFilter,
  contactTechSupportMessage,
  updateAssignmentStatusByTopic,
  sortStudentAssignmentsByName,
  sortStudentAssignments,
  updateStudentAssignmentsHidden,
  applyQuickSelection
} from './course-assign-util';
import {
  buildInstructionHubBlockedLookup,
  isInstructionHubBlockedAssignment
} from '../../helpers/instruction-hub/instruction-hub-assignments';

export const initialState = {
  isLoading: false,
  isLoadingStudentData: false,
  classrooms: [],
  filteredStudents: [],
  selectedStudentIds: [],
  studentsAssignmentStatus: [],
  studentsAssignmentCount: [],
  sortedStudents: [],
  sortDirection: 'asc',
  sortValue: 'lastName',
  showGridLoader: true,
  unsavedChanges: false,
  pausePolling: false,
  selectedCells: [],
  publications: [],
  genericCourses: [],
  publicationCourses: [],
  topics: [],
  selectedTopics: [],
  strands: [],
  selectedCourse: -1,
  assignmentStatuses: [],
  showSearchPanel: false,
  displayModalKey: -1,
  studentAssignments: [],
  actionInProgress: false,
  selectedLJIds: [],
  studentUnAssignments: [],
  selectedStandardCount: 0,
  standardCount: 0,
  activeClass: null,
  activeGroup: null,
  courseTopics: [],
  gridTopics: [],
  selectedCourseTopics: [],
  assignments: {
    isRestricted: true,
    totalAssignments: [],
    studentAssignments: []
  },
  selectedActivities: [],
  isTopicCollapsed: false,
  isTopicDirty: false,
  isLoadingResults: false,
  singleActivityReport: {},
  shouldClearFilter: false,
  studentResult: {},
  instructionHubBlockedLookup: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FILTERED_STUDENTS: {
      const { sortDirection, sortValue } = state;
      const sortedStudents = customSort(
        action.payload,
        sortValue,
        sortDirection
      );
      const orderedArr = [];
      const studentAssignments = state.assignments.studentAssignments;
      sortedStudents.forEach((sorted) => {
        studentAssignments.forEach((currentStudent) => {
          if (
            currentStudent.encryptedUserProfileId ===
            sorted.encryptedUserProfileId
          ) {
            orderedArr.push({ ...currentStudent, student: sorted });
          }
        });
      });
      return {
        ...state,
        filteredStudents: sortedStudents,
        sortedStudents,
        showGridLoader: true,
        selectedStudentIds: [],
        studentAssignments: [],
        studentUnAssignments: [],
        selectedLJIds: [],
        pausePolling: false,
        assignments: {
          ...state.assignments,
          studentAssignments: orderedArr
        }
      };
    }

    case actions.UPDATE_SORTED_STUDENTS_LIST: {
      const { sortDirection, sortValue } = state;
      const sortedStudents = customSort(
        action.students,
        sortValue,
        sortDirection
      );
      const studentAssignments = state.assignments.studentAssignments;
      return {
        ...state,
        sortedStudents,
        assignments: {
          ...state.assignments,
          studentAssignments: sortStudentAssignmentsByName(
            studentAssignments,
            sortedStudents
          )
        }
      };
    }

    case actions.UPDATE_SORTED_ASSIGNED_LIST: {
      const { sortDirection, sortValue } = state;
      const sortedList = customSort(
        action.assignedList,
        sortValue,
        sortDirection
      );
      return {
        ...state,
        sortedList
      };
    }

    case actions.UPDATE_SORT_PROPERTIES: {
      return {
        ...state,
        sortDirection: action.direction,
        sortValue: action.sortValue
      };
    }

    case actions.ERROR_DETECTED: {
      PortalCommunication.serverError(contactTechSupportMessage);
      return { ...state, isLoading: false };
    }

    case actions.CLASSROOMS_ACQUIRED: {
      PortalCommunication.loadingSpinnerOff();
      return {
        ...state,
        classrooms: action.payload.classroomList || [],
        isLoading: false
      };
    }

    case actions.UPDATE_SELECTED_TOPICS: {
      let updateTopics;
      let selectedTopicCount;
      if (action.payload.filterTopics) {
        ({ updateTopics, selectedTopicCount } = updateHiddenTopics(
          action.payload.filterTopics,
          action.payload.topics
        ));
      } else {
        ({ updateTopics, selectedTopicCount } = updateSelectedTopics(
          action.payload.topics
        ));
      }
      return {
        ...state,
        courseTopics: {},
        selectedCourseTopics: updateTopics,
        gridTopics: cloneDeep(updateTopics),
        selectedTopicCount
      };
    }

    case actions.UPDATE_TOPICS: {
      const { selectedCourseTopics } = state;
      const {
        id,
        checked,
        searchTerm,
        actionType,
        checkedNormal,
        checkedEasier
      } = action;
      const clonedCourseTopics = cloneDeep(selectedCourseTopics);

      let updatedTopicData = [];
      let updatedCourseTopics = [];

      switch (actionType) {
        case 'selection': {
          updatedCourseTopics = updateStrandAndStandards(
            id,
            checked,
            clonedCourseTopics
          );
          if (searchTerm && searchTerm !== '') {
            updatedTopicData = getFilteredTopics(
              searchTerm,
              updatedCourseTopics
            );
          } else {
            updatedTopicData = cloneDeep(updatedCourseTopics);
          }
          break;
        }

        case 'radioupdate': {
          updatedTopicData = updateActivitySelection(
            id,
            clonedCourseTopics,
            checkedNormal,
            checkedEasier
          );
          break;
        }

        case 'uncheckAll':
          updatedCourseTopics = updateCheckedStatus(false, clonedCourseTopics);
          updatedTopicData = updatedCourseTopics;
          break;

        case 'checkAll':
          updatedCourseTopics = updateCheckedStatus(true, clonedCourseTopics);
          updatedTopicData = updatedCourseTopics;
          break;

        case 'reset':
          updatedCourseTopics = updateStrands(true, clonedCourseTopics);
          updatedTopicData = updatedCourseTopics;
          break;

        default:
          updatedTopicData = getFilteredTopics(searchTerm, clonedCourseTopics);
          break;
      }

      return {
        ...state,
        selectedCourseTopics: updatedTopicData,
        selectedTopicCount: getSelectedStandardCount(updatedTopicData)
      };
    }

    case actions.APPLY_FILTER: {
      return {
        ...state,
        selectedCourseTopics: state.selectedCourseTopics,
        gridTopics: cloneDeep(state.selectedCourseTopics),
        selectedTopicCount: state.selectedTopicCount
      };
    }

    case actions.SHOW_HIDE_SEARCH_PANEL: {
      return {
        ...state,
        showSearchPanel: action.status,
        strands: state.strands.map((strand) => ({
          ...strand,
          isExpand: !!strand.childTopics.find((s) => s.selected)
        }))
      };
    }

    case actions.DISPLAY_MODAL_INFORMATION: {
      return {
        ...state,
        displayModalKey: action.key
      };
    }

    case actions.UPDATE_STUDENT_ASSIGNMENT: {
      const { assignments, instructionHubBlockedLookup } = state;
      const { index } = action;
      const studentAssignment = assignments.studentAssignments[index];
      if (
        studentAssignment &&
        isInstructionHubBlockedAssignment(
          studentAssignment,
          instructionHubBlockedLookup
        )
      ) {
        return state;
      }
      assignments.studentAssignments[index] = {
        ...assignments.studentAssignments[index],
        isSelected: !assignments.studentAssignments[index]?.isSelected
          ? true
          : undefined
      };
      return {
        ...state,
        assignments: {
          ...assignments,
          studentAssignments: assignments.studentAssignments
        }
      };
    }

    case actions.GRID_CELL_SELECTION: {
      const { indexes, status } = action;
      const { assignments } = state;
      return {
        ...state,
        actionInProgress: false,
        assignments: {
          ...assignments,
          studentAssignments: updateGridCells(
            indexes,
            assignments,
            status,
            state.instructionHubBlockedLookup
          )
        }
      };
    }

    case actions.SET_ACTIVE_CLASS: {
      return { ...state, activeClass: action.payload };
    }

    case actions.SET_ACTIVE_GROUP: {
      return { ...state, activeGroup: action.payload };
    }

    case actions.RESTRICT_ACCESS_FAILURE: {
      return { ...state, actionInProgress: false };
    }

    case actions.RESTRICT_ACCESS_REQUEST: {
      return { ...state, actionInProgress: true };
    }

    case actions.RESTRICT_ACCESS_SUCCESS: {
      return {
        ...state,
        actionInProgress: false,
        assignments: { ...state.assignments, isRestricted: action.payload }
      };
    }

    case actions.TOPICS_ACQUIRED_REQUEST: {
      return {
        ...state,
        actionInProgress: true
      };
    }

    case actions.TOPICS_ACQUIRED_SUCCESS: {
      return {
        ...state,
        actionInProgress: false,
        showGridLoader: false,
        assignments: {
          ...action.payload,
          studentAssignments: sortStudentAssignments(
            action.payload.studentAssignments,
            state.sortedStudents,
            state.selectedActivities
          )
        },
        instructionHubBlockedLookup: buildInstructionHubBlockedLookup(
          action.payload.studentAssignments,
          action.instructionHubConfig
        ),
        shouldClearFilter: true
      };
    }

    case actions.TOPICS_ACQUIRED_FAILURE: {
      return {
        ...state,
        actionInProgress: false,
        shouldClearFilter: true
      };
    }

    case actions.COURSE_TOPICS_ACQUIRED_SUCCESS: {
      return { ...state, courseTopics: action.payload };
    }

    case actions.UPDATE_SELECTED_ACTIVITIES: {
      return {
        ...state,
        selectedActivities: action.activities || [],
        assignments: {
          ...state.assignments,
          studentAssignments: updateStudentAssignmentsHidden(
            state.assignments.studentAssignments,
            action.activities || []
          )
        }
      };
    }

    case actions.UPDATE_COURSE_ID: {
      return { ...state, activeCourseID: action.payload.courseID };
    }

    case actions.TOGGLE_TOPICS_EXPAND_COLLAPSE: {
      return {
        ...state,
        isTopicCollapsed: action.setTopicsCollapsed,
        isTopicDirty: false
      };
    }

    case actions.SET_TOPIC_TO_DIRTY: {
      return {
        ...state,
        isTopicDirty: true
      };
    }

    case actions.UPDATE_DATE_PREFERENCE: {
      return {
        ...state,
        datePreference: action.payload
      };
    }

    case actions.QUICK_SELECTION: {
      const studentAssignments = applyQuickSelection(
        state.assignments.studentAssignments,
        action.selectionType,
        state.instructionHubBlockedLookup
      );

      if (!studentAssignments) {
        return { ...state };
      }

      return {
        ...state,
        assignments: {
          ...state.assignments,
          studentAssignments
        }
      };
    }

    case actions.SELECT_EQUAL_LESS_THAN_CELLS: {
      return {
        ...state,
        assignments: {
          ...state.assignments,
          studentAssignments: state.assignments.studentAssignments.map(
            (studentAssignment) => ({
              ...studentAssignment,
              isSelected:
                isDefined(studentAssignment?.result?.score) &&
                studentAssignment?.result?.score <= action.result &&
                studentAssignment.encryptedUserProfileId ===
                  action.currentStudent.encryptedUserProfileId &&
                !isInstructionHubBlockedAssignment(
                  studentAssignment,
                  state.instructionHubBlockedLookup
                )
                  ? true
                  : studentAssignment.isSelected
            })
          )
        }
      };
    }

    case actions.STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST: {
      return {
        ...state,
        isLoadingResults: true
      };
    }

    case actions.STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS: {
      return {
        ...state,
        isLoadingResults: false,
        singleActivityReport: action.payload
      };
    }

    case actions.UPDATE_ASSIGNMENT_FILTERS: {
      return {
        ...state,
        assignments: {
          ...state.assignments,
          studentAssignments: state.assignments.studentAssignments.map(
            (studentAssignment) =>
              checkIfAssignmentPassesFilter(studentAssignment, action.payload)
          )
        }
      };
    }

    case actions.CLEAR_ASSIGNMENT_FILTERS: {
      return {
        ...state,
        assignments: {
          ...state.assignments,
          studentAssignments: state.assignments.studentAssignments.map(
            (studentAssignment) => ({ ...studentAssignment, isFiltered: false })
          )
        },
        shouldClearFilter: false
      };
    }

    case actions.STUDENT_RESULT_REQUEST: {
      return {
        ...state,
        isLoadingResults: true
      };
    }

    case actions.STUDENT_RESULT_SUCCESS: {
      return {
        ...state,
        isLoadingResults: false,
        studentResult: action.payload
      };
    }

    case actions.UPDATE_STUDENT_ASSIGNMENTS_SELECTED: {
      return {
        ...state,
        assignments: {
          ...state.assignments,
          studentAssignments: updateAssignmentStatusByTopic(
            action.payload.activities,
            action.payload.encryptedUserProfileId,
            state.assignments.studentAssignments,
            state.instructionHubBlockedLookup
          )
        }
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./containers/course-assign/course-assign-reducer.js